import { render } from "./MovieDetails.vue?vue&type=template&id=3b5b6fba&scoped=true"
import script from "./MovieDetails.vue?vue&type=script&lang=js"
export * from "./MovieDetails.vue?vue&type=script&lang=js"

import "./detailsCard.css?vue&type=style&index=0&id=3b5b6fba&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5b6fba"]])

export default __exports__